import React from 'react';
import { Typography, Link } from '@mui/material';

interface MessageProps {
  message: any;
}

const MessageLocation: React.FC<MessageProps> = ({ message }) => {
  try {
    const { latitude, longitude } = message?.content?.location || message?.content|| {};
    const locationText =
      latitude && longitude ? `Location: ${latitude}, ${longitude}` : 'Send current location';
    const locationUrl =
      latitude && longitude
        ? `https://www.google.com/search?q=${latitude},${longitude}`
        : '';

    return (
      <>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          View Location
        </Typography>

        {locationUrl ? (
          <Link
            href={locationUrl}
            target="_blank"
            rel="noopener"
            underline="hover"
            color="primary"
          >
            {locationUrl}
          </Link>
        ) : (
          <Typography variant="body2">No location available</Typography>
        )}

        <Typography variant="body2" mt={1}>
          {message?.content?.text || locationText}
        </Typography>
      </>
    );
  } catch (error) {
    return <div>Error rendering location</div>;
  }
};

export default MessageLocation;
